// Compact stat tile used inside the right-side drill panel.

import React from 'react';
import { Box, Typography } from '@mui/material';

import { ACCENTS } from './peopleInsightsTokens';

export interface StatTileProps {
  label: string;
  value: React.ReactNode;
  positive?: boolean;
  /** Use the smaller variant when the value is a long string (e.g. a name). */
  small?: boolean;
}

const StatTile: React.FC<StatTileProps> = ({ label, value, positive, small }) => (
  <Box
    sx={{
      backgroundColor: '#F8FAFC',
      borderRadius: 1.5,
      px: 1.5,
      py: 1.25,
      minWidth: 0,
    }}
  >
    <Typography
      variant="caption"
      sx={{
        color: 'text.secondary',
        display: 'block',
        textTransform: 'uppercase',
        letterSpacing: '0.04em',
        fontWeight: 500,
      }}
    >
      {label}
    </Typography>
    <Typography
      sx={{
        fontSize: small ? '0.875rem' : '1.125rem',
        fontWeight: 700,
        lineHeight: 1.2,
        mt: 0.5,
        color: positive ? ACCENTS.emerald.on : 'text.primary',
        wordBreak: 'break-word',
      }}
    >
      {value}
    </Typography>
  </Box>
);

export default StatTile;
